import React, { useState } from "react";
import { Modal, Form, Input, Button, Select } from "antd";

import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";
import { useQueryClient } from "@tanstack/react-query";
import { useWorkers } from "context/providers/workers";
import { special_characters_regexp } from "helpers/regexp";

const CreateNoteModal = () => {
  const queryClient = useQueryClient();
  const { all_users_list_options } = useWorkers();
  const [is_open_create_modal, setOpenCreateModal] = useState(false);

  const [form] = Form.useForm();

  const { pristine, has_error, onFieldsChange } = useFormErrors();

  const { is_saving, create } = useCreate({
    path: "/notes",
    form,
    onSuccess: () =>
      queryClient.refetchQueries({
        queryKey: ["notes"],
      }),
  });

  const handleOk = () => form.submit();
  const handleClose = () => setOpenCreateModal(false);

  return (
    <>
      <Button
        type="primary"
        htmlType="button"
        onClick={() => setOpenCreateModal(true)}
      >
        Dodaj notatkę
      </Button>
      <Modal
        style={{ top: 45 }}
        maskClosable={false}
        title="Dodaj notatkę"
        open={is_open_create_modal}
        onOk={handleOk}
        onCancel={handleClose}
        cancelText="Anuluj"
        okText="Dodaj"
        okButtonProps={{
          disabled: pristine || has_error,
          loading: is_saving,
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFieldsChange={onFieldsChange}
          initialValues={{
            content: "",
            user_id: null,
          }}
          onFinish={async (values) => {
            try {
              await create(values);
              form.resetFields();
              handleClose();
            } catch (error) {
              throw error;
            }
          }}
        >
          <Form.Item
            label="Pracownik"
            name="user_id"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Pracownik jest wymagany!",
              },
            ]}
          >
            <Select placeholder="Pracownik" options={all_users_list_options} />
          </Form.Item>

          <Form.Item
            label="Treść"
            name="content"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Treść jest wymagana!",
              },
              {
                pattern: special_characters_regexp,
                message: "Pole zawiera niedozwolone znaki!!",
              },
            ]}
          >
            <Input.TextArea
              style={{ marginBottom: 10 }}
              placeholder="Treść"
              maxLength={400}
              showCount={true}
              rows={7}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateNoteModal;
